var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast-wrapper"},[_c('div',{staticClass:"base-toast",style:({width: _vm.width + 'px'})},[_vm._m(0),_c('div',{staticClass:"message"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.toastMessage))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":require("../../../public/custom/images/Success.svg"),"alt":"success icon"}})])
}]

export { render, staticRenderFns }